'use client';

import { getAuth, RecaptchaVerifier } from 'firebase/auth';

let recaptchaVerifier: RecaptchaVerifier;
let container: HTMLElement;

if (typeof window !== 'undefined') {
  container = document.createElement('div');
  container.id = 'recaptcha-container';
  container.style.position = 'absolute';
  container.style.top = '0';
  container.style.zIndex = '99';
  document.body.appendChild(container);

  recaptchaVerifier = new RecaptchaVerifier(getAuth(), container, { size: 'invisible' });
}

export const showContainer = () => {
  if (container) {
    container.hidden = false;
  }
};
export { recaptchaVerifier };
